import AytMatematik from "../pages/matematik/ayt/AytMatematik";


export const MatematikAyt = [
  {
    path: "/matematik/ayt",
    element: <AytMatematik activeDivProps={1} />
  }
];

